export default {
    container: {},
    containerLandscape: {},
    pickerView: {},
    pickerViewLandscape: {},
};
